import './spin.css';

function FastSpin(){
    return(
        <>


        <div>
            <div className='spinner'>

            </div>
            <p className='sam_abs' style={{color:'#fff', fontSize:'15px', wordSpacing:'1px'}}>Setting up now...</p>

        </div>


        </>
    )
};

export default FastSpin;